<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li *ngIf="canManageSettings" [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Global' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-global-settings></ca-global-settings>
      </ng-template>
    </li>
    <li *ngIf="canManageSettings && isSuperAdminUser && whiteLabelingEnabled" [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::CorporateIdentity' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-corporate-identity-settings></ca-corporate-identity-settings>
      </ng-template>
    </li>
    <li *ngIf="canManageSettings && isSuperAdminUser" [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Licensing' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-licensing-settings></ca-licensing-settings>
      </ng-template>
    </li>
    <li *ngIf="canManageSettings && externalLoginEnabled" [ngbNavItem]="4">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::ExternalLogin' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-external-login-settings></ca-external-login-settings>
      </ng-template>
    </li>
    <li *ngIf="canManageSettings" [ngbNavItem]="5">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::FileCompression:Title' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-file-compression-settings></ca-file-compression-settings>
      </ng-template>
    </li>
    <li *ngIf="canManageSettings && isSuperAdminUser" [ngbNavItem]="7">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::InteractionManagement' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-interaction-management-settings></ca-interaction-management-settings>
      </ng-template>
    </li>
    <li [ngbNavItem]="6">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Definitions' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-setting-definitions
          [information]="'Settings::SettingsDefinitionInfo'"
          [items]="settingsDefinitionItems"></ca-setting-definitions>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
